import { Table, TableData, TableRow } from '@cokitchen/cokitchen-components';
import { PLUS_ICON } from 'assets/icons/siderbar-icons';
import SelectDropdown from 'components/base/select-dropdown';
import useSettingsContext from 'contexts/settings.context/context';
import { CreateUserType } from 'contexts/settings.context/provider';
import React, { useEffect } from 'react';
import { apiService } from 'services/base.service';
import { DeleteIcon } from 'cokitchen-icons';
import EditableInput from 'components/base/editable-input';

const USER_HEADERS = ['First Name', 'Last Name', 'Email', 'Phone Number', 'Role', 'Actions'];

export const DefaultUserFormData: CreateUserType = {
  phone_number: '',
  first_name: '',
  last_name: '',
  email: '',
  role: { id: '', name: '' }
};
const AddUserDetails = () => {
  const { userFormData, setUserFormData, roles, setRoles } = useSettingsContext();

  const handleChange = (field: string, value: string, index: number) => {
    setUserFormData((prev) =>
      prev.map((itm, i) => (i === index ? { ...itm, [field]: value } : itm))
    );
  };

  const addUser = () => {
    setUserFormData((prev) => [...prev, { ...DefaultUserFormData }]);
  };

  const removeUser = (index: number) => {
    setUserFormData((prev) => prev.filter((item, i) => index !== i));
  };

  const getRoles = async () => {
    try {
      const res = await apiService.get('user/role');
      setRoles(res?.data?.data);
    } catch (e: any) {
      console.log(e);
    }
  };
  useEffect(() => {
    getRoles();
  }, []);

  return (
    <div>
      <div className='flex justify-between mb-6'>
        <h3 className='text-xl font-semibold'>Add new user</h3>
      </div>

      <Table headers={USER_HEADERS}>
        {userFormData?.map((user, index) => {
          return (
            <TableRow key={index} className='hover:bg-gray-50 transition-colors'>
              <TableData className='px-2 py-2 text-sm'>
                <EditableInput
                  isEditing
                  value={user.first_name}
                  onChange={(e) => handleChange('first_name', e.target.value, index)}
                  placeholder='e.g Omo-Idonije'
                />
              </TableData>

              <TableData className='px-2 py-2 text-sm'>
                <EditableInput
                  isEditing
                  value={user.last_name}
                  onChange={(e) => handleChange('last_name', e.target.value, index)}
                  placeholder='e.g Idonije'
                />
              </TableData>

              <TableData className='px-2 py-2 text-sm'>
                <EditableInput
                  isEditing
                  value={user.email}
                  type='email'
                  onChange={(e) => handleChange('email', e.target.value, index)}
                  placeholder='e.g Esther@foodcourt.co'
                />
              </TableData>

              <TableData className='px-2 py-2 text-sm'>
                <EditableInput
                  isEditing
                  value={user.phone_number}
                  onChange={(e) => handleChange('phone_number', e.target.value, index)}
                  type='tel'
                  placeholder='e.g 070XXX'
                />
              </TableData>

              <TableData className='px-2 py-2 text-sm'>
                <SelectDropdown
                  placeholder='Select role'
                  value={user.role.name}
                  setValue={(role) => {
                    handleChange('role', role, index);
                  }}
                  options={roles}
                />
              </TableData>

              <TableData className='px-2 py-2 text-sm'>
                <div className='flex items-center justify-center'>
                  {userFormData.length > 1 && (
                    <div className='cursor-pointer text-red-5' onClick={() => removeUser(index)}>
                      <DeleteIcon />
                    </div>
                  )}
                </div>
              </TableData>
            </TableRow>
          );
        })}
      </Table>

      <button
        onClick={addUser}
        className='text-[#0080E5] mt-6 font-medium text-sm border border-[#E5E6E6] border-dashed rounded-[100px] px-2 py-1 flex gap-1 items-center'>
        <PLUS_ICON />
        Add another user
      </button>
    </div>
  );
};
export default AddUserDetails;
